import { MouseEvent, useState } from 'react'

import { useMe } from '@/providers'
import { faBell } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Badge, IconButton, IconButtonProps } from '@mui/material'
import { getTestId } from '@utils/helpers'
import NotificationPopover from '@views/Layout/PageHeader/NotificationPopover/NotificationPopover'

type UIProps = IconButtonProps & {
	count: number
	open?: boolean
}

export default function NotificationBell(props: IconButtonProps) {
	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
	const me = useMe()

	const handleOpen = (e: MouseEvent<HTMLElement>) => setAnchorEl(e.currentTarget)
	const handleClose = () => setAnchorEl(null)

	return (
		<>
			<NotificationBellUI
				count={me?.unreadNotificationCount || 0}
				open={Boolean(anchorEl)}
				onClick={handleOpen}
				{...props}
			/>
			{anchorEl && <NotificationPopover anchorEl={anchorEl} onClose={handleClose} />}
		</>
	)
}

export function NotificationBellUI({ count, open = false, ...rest }: UIProps) {
	const testId = getTestId(rest, 'notification-bell')

	return (
		<IconButton
			aria-label="Notifications"
			aria-haspopup="true"
			aria-expanded={open ? 'true' : undefined}
			data-testid={testId}
			{...rest}
		>
			<Badge badgeContent={count} max={9} invisible={!count} color="secondary" overlap="circular">
				<FontAwesomeIcon icon={faBell} size="sm" color="white" />
			</Badge>
		</IconButton>
	)
}
